import { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { COMMON_MOBILE_BREAKPOINT } from '@elfsight/lib-utils';
import type { Mode } from '../../types';
import { useModeData } from '../data/use-mode-data';
import { Block } from './block';
import { ModeItem } from './mode-item';
import { MoreSettings } from './more-settings';

export function ModeBlock() {
  const modeData = useModeData();

  const modes = useMemo(
    () =>
      Object.entries(modeData).map(([modeName, modeData]) => ({
        key: modeName,
        modeName: modeName as Mode,
        ...modeData
      })),
    [modeData]
  );

  return (
    <StyledBlock role="radiogroup">
      {modes.map(({ key, ...modeData }) => (
        <ModeItem key={key} {...modeData} />
      ))}

      <Separator />
      <MoreSettings />
    </StyledBlock>
  );
}

const StyledBlock = styled(Block)`
  @media (max-width: ${COMMON_MOBILE_BREAKPOINT}px) {
    gap: 12px;
    background-color: transparent;
    padding: 16px 8px 0;
  }
`;

const Separator = styled.div`
  ${({ theme }) => css`
    height: 1px;
    background-color: ${theme.modeBlock.separatorColor};
    margin: 8px 15px;

    @media (max-width: ${COMMON_MOBILE_BREAKPOINT}px) {
      display: none;
    }
  `}
`;
